import { DayWofWeek, EmsTimeRange, EmsPeriodLegacyApiResource, PeriodChargeType } from 'src/Libs/smart-charge/api/types'
import { INPUT_WEEKDAY_SEQUENCE } from 'src/Libs/smart-charge/config'
import { PeriodFormInputType } from 'src/Libs/types'
import { EmsIdlePeriodLegacyFormField } from 'src/Libs/smart-charge/types'

const periodToInputTime = (period?: EmsTimeRange): string => {
  if (!period) {
    return ''
  }

  return [period.emsIdlePeriodHour.toString().padStart(2, '0'), period.emsIdlePeriodMinute.toString().padStart(2, '0')].join(':')
}

const buildPeriodFromForm = (item: PeriodFormInputType, dayOfWeek: DayWofWeek, type: PeriodChargeType): EmsPeriodLegacyApiResource => {
  const startTime = (item.start || '00:00').split(':').map(Number)
  const endTime = (item.end || '00:00').split(':').map(Number)
  return {
    emsIdlePeriodEnd: { emsIdlePeriodHour: endTime[0], emsIdlePeriodMinute: endTime[1] },
    emsIdlePeriodStart: { emsIdlePeriodHour: startTime[0], emsIdlePeriodMinute: startTime[1] },
    emsIdlePeriodActive: item.isActive,
    emsIdlePeriodType: type,
    emsIdlePeriodDay: dayOfWeek,
  }
}

const idlePeriodFormFieldToPeriodPair = (idlePeriodFormField: EmsIdlePeriodLegacyFormField): EmsPeriodLegacyApiResource[] => {
  const entries = [] as EmsPeriodLegacyApiResource[]

  entries.push(buildPeriodFromForm(idlePeriodFormField.charge, idlePeriodFormField.dayOfWeek, PeriodChargeType.charge))
  entries.push(buildPeriodFromForm(idlePeriodFormField.discharge, idlePeriodFormField.dayOfWeek, PeriodChargeType.discharge))
  return entries
}

const flattenPeriodPair = (previousValue: EmsPeriodLegacyApiResource[], currentValue: EmsPeriodLegacyApiResource[]): EmsPeriodLegacyApiResource[] => {
  return [...previousValue, ...currentValue]
}

export const legacyIdlePeriodFormToDto = (values: EmsIdlePeriodLegacyFormField[]): EmsPeriodLegacyApiResource[] => {
  return (
    values
      /* TODO: tmp. disabled because of api changes. if this does not make any trouble on beta, we can remove it */
      // .filter(idlePeriodFormField => idlePeriodFormField.charge.isActive || idlePeriodFormField.discharge.isActive)
      .map(idlePeriodFormFieldToPeriodPair)
      .reduce(flattenPeriodPair, [])
  )
}
export const legacyIdlePeriodModelToForm = (values: EmsPeriodLegacyApiResource[]): EmsIdlePeriodLegacyFormField[] => {
  return INPUT_WEEKDAY_SEQUENCE.map(dayOfWeek => {
    const periodsByWeekday = values.filter(period => period.emsIdlePeriodDay === dayOfWeek)

    const charging = periodsByWeekday.find(idlePeriod => idlePeriod.emsIdlePeriodType === PeriodChargeType.charge, null)
    const discharging = periodsByWeekday.find(idlePeriod => idlePeriod.emsIdlePeriodType === PeriodChargeType.discharge, null)

    return {
      dayOfWeek: dayOfWeek,
      charge: {
        isActive: charging?.emsIdlePeriodActive || false,
        start: periodToInputTime(charging?.emsIdlePeriodStart),
        end: periodToInputTime(charging?.emsIdlePeriodEnd),
      },
      discharge: {
        isActive: discharging?.emsIdlePeriodActive || false,
        start: periodToInputTime(discharging?.emsIdlePeriodStart),
        end: periodToInputTime(discharging?.emsIdlePeriodEnd),
      },
    }
  })
}
